var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBimify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 24,
    viewBox: "0 0 76 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3636 12.4909C35.3636 15 33.6182 16.8 31.1091 16.8C30.1818 16.8 29.3091 16.4727 28.6545 15.9273L28.3818 16.5273H26.3091V5.50908H29.0909V8.72726C29.6909 8.34544 30.3454 8.18181 31.1091 8.18181C33.6182 8.18181 35.3636 9.98181 35.3636 12.4909ZM32.5273 12.4909C32.5273 11.4545 31.7636 10.6364 30.7273 10.6364C29.6909 10.6364 28.9273 11.4 28.9273 12.4909C28.9273 13.5273 29.6909 14.3454 30.7273 14.3454C31.7636 14.3454 32.5273 13.5273 32.5273 12.4909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6727 8.45454H39.4545V16.5818H36.6727V8.45454ZM36.6727 5.07272H39.4V7.41818H36.6727V5.07272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6363 11.4545V16.5273H50.8545V11.7818C50.8545 10.9091 50.5272 10.5273 49.9272 10.5273C49.1636 10.5273 48.7818 11.0727 48.7818 12.0545V16.5273H46.0545V11.7818C46.0545 10.9636 45.7272 10.5273 45.1818 10.5273C44.4182 10.5273 44.0363 11.0727 44.0363 12.0545V16.5273H41.2545V8.45455H43.2182L43.6 9.32728C44.2 8.61818 45.0182 8.23637 45.9454 8.23637C46.9272 8.23637 47.7454 8.67273 48.2909 9.43637C48.8909 8.72728 49.7636 8.23637 50.8 8.23637C52.4909 8.18182 53.6363 9.54546 53.6363 11.4545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3273 8.45454H58.1091V16.5818H55.3273V8.45454ZM55.3273 5.07272H58.0545V7.41818H55.3273V5.07272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3091 10.6364H63.5091V16.5273H60.7273V10.6364H59.3636V8.45454H60.7273V7.79999C60.7273 6.16363 61.6 5.23636 63.3455 5.23636H65.3091V7.36363H64.0546C63.6182 7.36363 63.4 7.58181 63.4 8.01818V8.45454H65.3091V10.6364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1817 8.45454L71.7999 16.2C70.709 18.7091 69.7272 19.5818 67.5999 19.5818H66.6181V17.1818H67.3817C68.4727 17.1818 68.7999 16.9091 69.1272 15.8727L65.7999 8.45454H68.8545L70.5999 12.9273L72.1817 8.45454H75.1817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5637 5.61818L11.9637 0.109086C11.7455 -5.26756e-06 11.5273 -5.26756e-06 11.3091 0.109086L0.781863 6.16363C0.563681 6.27272 0.45459 6.4909 0.45459 6.70908V17.8364C0.45459 18.0545 0.563681 18.2727 0.781863 18.3818L10.3273 23.8909C10.5455 24 10.8728 24 11.091 23.8909L14.0364 22.2C14.2 22.0909 14.2 21.8727 14.0364 21.7636L4.49095 16.2C4.27277 16.0909 4.16368 15.8727 4.16368 15.6545V8.8909C4.16368 8.67272 4.27277 8.45454 4.49095 8.34545L7.38186 6.65454C7.43641 6.59999 7.5455 6.59999 7.60004 6.54545C7.76368 6.4909 7.87277 6.59999 7.87277 6.76363V13.5273C7.87277 13.7454 7.98186 13.9636 8.20004 14.0727L13.8728 17.3454C14.1455 17.5091 14.4182 17.2909 14.4182 17.0182V10.4182C14.4182 10.2545 14.5273 10.0909 14.6364 9.98181L17.7455 8.18181C17.9091 8.07272 18.1273 8.18181 18.1273 8.39999V19.2C18.1273 19.4727 18.4546 19.6909 18.6728 19.5273L21.5091 17.8909C21.7273 17.7818 21.8364 17.5636 21.8364 17.3454V6.21818C21.891 5.94545 21.7819 5.72727 21.5637 5.61818Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.7273,
    height: 24,
    fill: "white",
    transform: "translate(0.45459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBimify);
export default __webpack_public_path__ + "static/media/logo-bimify.d6238295d16fba4dc06c6e4f2aa2ad64.svg";
export { ForwardRef as ReactComponent };